module.exports = __webpack_public_path__ + "static/media/lightning2.6f20cc52.png";